import { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { AppContext } from '@state/context'
import useSWR from 'swr'
import { Books_Listing } from '@graphql/queries'
import { removeDuplicates } from '@helpers/utilities'
import { useCurrentUser } from './useCurrentUser'

const useBooks = () => {
  const [state] = useContext(AppContext)
  const userId = state?.app?.userId
  const { currentUser } = useCurrentUser()
  const { data, error, mutate, isValidating } = useSWR(Books_Listing)
  const [books, setBooks] = useState([])
  const [userCreatedBooks, setUserCreatedBooks] = useState([])
  const [publicBooks, setPublicBooks] = useState([])
  const [userBooks, setUserBooks] = useState([])

  const userSavedBooks = useMemo(() => {
    if (!currentUser?.books || !data?.books?.data) return []

    const flatUserBookIds = currentUser.books.flatMap(b => b.id)

    return data.books.data.filter((b) => b.customers.some((c) => c.id === userId))
      .sort((a, b) => flatUserBookIds.indexOf(a.id) - flatUserBookIds.indexOf(b.id))
  }, [data, currentUser])

  useEffect(() => {
    if (data?.books?.data) {
      const createdBooks = data.books.data.filter((book) => book.creator?.id === userId)

      setBooks(data.books.data)
      setUserCreatedBooks(createdBooks)
      setPublicBooks(data.books.data.filter((book) => book.published === true))
      setUserBooks(removeDuplicates(createdBooks.concat(userSavedBooks)))
    }
  }, [userId, data, isValidating, userSavedBooks])

  return {
    userBooks,
    userCreatedBooks,
    publicBooks,
    userSavedBooks,
    books,
    error,
    mutate,
    isValidating,
    isLoading: !error && !data && !books.length !== data?.books?.length,
  }
}

export { useBooks }
